<template>
    <main id="liste" v-cloak>
        <HeaderTab :title="$t('monte.congelation.expeditions')" :swiper_tabs="swiper_tabs" />

        <div id="content">
            <div class="container-fluid">
                <div class="row">
                    <div class="col-12">
                        <div>
                            <router-view></router-view>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </main>
</template>


<script type="text/javascript">
    import Navigation from "@/mixins/Navigation.js";

	export default {
		name: "CongelationExpedition",
		mixins: [Navigation],
		data () {
			return {
            }
		},
        computed: {
            swiper_tabs() {
                return [{
                        id: 'attente',
                        label: 'menu.congelation.attente',
                        active: false,
                        href : 'CongelationExpeditionAttente',
                        icon: ['far', 'truck-loading']
                    },
                    {
                        id: 'expedies',
                        label: 'menu.congelation.expedies',
                        active: false,
                        href : 'CongelationExpeditionExpedies'
                    },
                    {
                        id: 'livres',
                        label: 'menu.congelation.livres',
                        active: false,
                        href : 'CongelationExpeditionLivres'
                    },
                    {
                        id: 'recherche',
                        label: 'menu.congelation.recherche',
                        active: false,
                        href : 'CongelationExpeditionRecherche'
                    },
                    {
                        id: 'cuve_shipped',
                        label: 'monte.congelation.cuve_shipped',
                        active: false,
                        href : 'CongelationCuveShipped'
                    }
                ]
            },
        },
		components: {
            HeaderTab: () => import('@/components/HeaderTab'),
		}
	}
</script>
